import styles from './ccf-simulator-v2-outbound-phone-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfSimulatorV2OutboundPhoneIconProps {}

export function CcfSimulatorV2OutboundPhoneIcon(
  props: CcfSimulatorV2OutboundPhoneIconProps
) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      sx={{ fontSize: 20 }}
    >
      <path
        d="M15.3781 13.1788C15.3781 13.1788 14.4972 14.5558 14.4159 14.6734C14.3346 14.7911 14.1647 15.1394 13.3445 14.9064C12.4441 14.6489 10.8958 13.9243 8.49089 11.5152C6.95984 10.1895 5.79502 8.52002 5.10067 6.65619C4.86649 5.84072 5.2123 5.66598 5.33 5.58443C5.4477 5.50289 6.82369 4.62218 6.82369 4.62218C7.74951 4.07931 6.70235 1.75406 5.01209 0.636872C3.76351 -0.189081 3.21627 -0.1087 2.6933 0.297869C1.83824 0.981958 1.07413 1.76448 0.418186 2.62778C0.085596 3.09292 -0.0561531 3.65969 0.0201927 4.21911C0.292274 5.98962 0.923865 7.69159 1.87911 9.22841C2.95241 11.0467 4.26923 12.7222 5.79595 14.2121C7.26829 15.7244 8.94373 17.0419 10.7781 18.1298C12.2927 19.0749 13.9964 19.7055 15.7797 19.9809C16.344 20.0549 16.9158 19.9117 17.3705 19.5825C18.2424 18.9191 19.0257 18.1549 19.7027 17.3074C20.1091 16.7831 20.188 16.2356 19.3641 14.988C18.2454 13.2999 15.9217 12.2526 15.3781 13.1788Z"
        fill="black"
      />
      <path
        d="M15.7762 8.78849L15.7565 4.46758L17.4612 4.4764C17.7552 4.47612 17.8618 4.2777 17.6997 4.03079L15.2338 0.310598C15.0704 0.0676378 14.8052 0.0636474 14.6451 0.309217L12.2085 4.00758C12.0484 4.25315 12.154 4.45031 12.4507 4.45523L14.1534 4.46211L14.1737 8.78105C14.1758 8.99582 14.2607 9.1995 14.4108 9.3496C14.5609 9.4997 14.7646 9.58463 14.9794 9.58667C15.0834 9.58729 15.1869 9.56692 15.2839 9.52676C15.3808 9.48661 15.4691 9.42751 15.5435 9.35299C15.6179 9.27847 15.6768 9.19007 15.7168 9.09308C15.7568 8.99608 15.777 8.89249 15.7762 8.78849Z"
        fill="black"
      />
    </SvgIcon>
  );
}

export default CcfSimulatorV2OutboundPhoneIcon;
